
import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      icon: 'ri-user-fill',
      title: 'Créditos Personales',
      description: 'Financiamiento para proyectos personales con tasas competitivas y plazos flexibles.',
      features: ['Hasta $50,000 USD', 'Plazos de 12 a 60 meses', 'Aprobación en 48 horas'],
      image: 'https://public.readdy.ai/ai/img_res/8a66bd4c6c8ee2575d7bc8e06e9b5b83.jpg'
    },
    {
      icon: 'ri-flashlight-fill',
      title: 'Microcréditos Rápidos',
      description: 'Soluciones ágiles para necesidades inmediatas con proceso simplificado.',
      features: ['Desde $500 USD', 'Aprobación en 24 horas', 'Requisitos mínimos'],
      image: 'https://readdy.ai/api/search-image?query=Small%20business%20owner%20receiving%20quick%20microcredit%20approval%20on%20smartphone%2C%20modern%20financial%20technology%20interface%2C%20fast%20and%20efficient%20service%20concept%2C%20clean%20simple%20background%20with%20emerald%20green%20accents%2C%20professional%20photography%20showing%20speed%20and%20accessibility%20in%20microfinance%20solutions&width=600&height=400&seq=service-microcredits&orientation=landscape'
    },
    {
      icon: 'ri-building-fill',
      title: 'Financiamiento Empresarial',
      description: 'Capital de trabajo y expansión para pequeñas y medianas empresas.',
      features: ['Hasta $500,000 USD', 'Plazos hasta 84 meses', 'Asesoría especializada'],
      image: 'https://readdy.ai/api/search-image?query=Corporate%20business%20meeting%20discussing%20company%20financing%20and%20growth%20strategy%2C%20professional%20executives%20reviewing%20business%20expansion%20plans%2C%20modern%20conference%20room%20with%20financial%20charts%2C%20sophisticated%20corporate%20environment%20with%20emerald%20and%20slate%20tones%2C%20high-end%20business%20photography&width=600&height=400&seq=service-business-financing&orientation=landscape'
    },
    {
      icon: 'ri-home-fill',
      title: 'Créditos Hipotecarios',
      description: 'Financiamiento para adquisición de vivienda con respaldo institucional.',
      features: ['Hasta 80% del valor', 'Plazos hasta 30 años', 'Tasas preferenciales'],
      image: 'https://readdy.ai/api/search-image?query=Happy%20family%20receiving%20house%20keys%20from%20real%20estate%20agent%2C%20modern%20residential%20property%20in%20background%2C%20professional%20mortgage%20approval%20moment%2C%20clean%20architectural%20setting%20with%20natural%20light%2C%20emerald%20and%20slate%20color%20palette%2C%20corporate%20real%20estate%20photography%20showing%20trust%20and%20achievement&width=600&height=400&seq=service-mortgage-loans&orientation=landscape'
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            Nuestros Servicios Financieros
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Soluciones profesionales adaptadas a tus necesidades personales y empresariales
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {services.map((service, index) => (
            <div key={index} className="bg-slate-50 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow group">
              <div className="h-64 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-white text-xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-800 mb-3">{service.title}</h3>
                <p className="text-slate-600 mb-6 leading-relaxed">{service.description}</p>
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-slate-700">
                      <i className="ri-checkbox-circle-fill text-emerald-600 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <p className="text-xs text-slate-500 italic mb-4">
                  * Sujeto a evaluación crediticia y cumplimiento de requisitos
                </p>
                <Link to="/servicios" className="inline-flex items-center text-emerald-600 font-semibold text-sm hover:text-emerald-700 transition-colors whitespace-nowrap">
                  Más información
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link to="/servicios" className="inline-block px-8 py-4 bg-emerald-600 text-white font-semibold rounded-lg hover:bg-emerald-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap">
            Ver Todos los Servicios
          </Link>
        </div>
      </div>
    </section>
  );
}
